export default __webpack_public_path__ + "static/media/dentist.93d1a660.svg";